export enum AdminTeamsRoutes {
  CreateTeam = 'create-team',
  GetTeams = 'get-teams',
  UpdateTeam = 'update-team',
}
